import type { Partner } from "@expert/shared-types";

import { getRootDispatcher } from "@/analytics";

/**
 * The analytics (EDP) dispatcher for a call's C360 events, carrying what every one of them needs: the session's
 * `SessionId` and `SupportSessionId`, so it joins to `SupportSessionStarted` and `SupportSessionClosed`, and the partner
 * as `Client`.
 */
export function c360Dispatcher(sessionId: string, partner: Partner) {
    return getRootDispatcher()
        .withMeta({ Client: partner, Channel: "Call" })
        .withIdentities({ SessionId: sessionId, SupportSessionId: sessionId });
}
